import { Button, Popover, Stack, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

const PopoverComponent = ({
  id,
  open,
  anchorEl,
  handlePopoverClose,
  handler,
  isLoading,
  caption,
}: {
  id?: string;
  open: boolean;
  anchorEl: any;
  handlePopoverClose: () => void; // نوع تابع را مشخص کنید
  handler: () => void; // نوع تابع را مشخص کنید
  isLoading: boolean;
  caption: string;
}) => {
  return (
    // اضافه کردن کلمه کلیدی return
    <Popover
      id={id}
      key={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <div className="p-2">
        <Typography textAlign={"center"} className="mb-2">
          {caption}
        </Typography>
        <Stack direction="row" spacing={1}>
          <LoadingButton
            onClick={handler}
            variant="contained"
            color="success"
            size="small"
            loading={isLoading}
          >
            بله
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={handlePopoverClose}
          >
            خیر
          </Button>
        </Stack>
      </div>
    </Popover>
  );
};

export default PopoverComponent;
